export const TERMS_UPDATED = "28 June 2026";

export const TERMS_INTRO = [
  'These Terms and Conditions ("Legal Terms") constitute a legally binding agreement between you ("you" or "user") and Harman AI Solutions ("Company", "we", "us", "our"), concerning your access to and use of our website at https://harmanaisolutions.com and any related services we provide (collectively, the "Services").',
  "By accessing the Services, you confirm that you have read, understood, and agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND MUST DISCONTINUE USE IMMEDIATELY.",
  "We reserve the right to make changes or modifications to these Legal Terms at any time and for any reason. We will notify you of any updates by sending an email notification to the address you provided. The updated date at the top of these Legal Terms will also be revised. We recommend that you print or save a copy of these Legal Terms for your records.",
  "You can contact us by email at: team@harmanaisolutions.com.",
];

export const TERMS_SECTIONS = [
  {
    title: "1. Our Services",
    paras: [
      "Harman AI Solutions is a website design and build service for small businesses. We create professional, mobile-friendly websites and hand them over fully live and ready to use, for a one-off fixed fee.",
      "The information provided when using the Services is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation. Persons who choose to access the Services from other locations do so on their own initiative and are solely responsible for compliance with local laws.",
    ],
  },
  {
    title: "2. Intellectual Property Rights",
    paras: [
      'We are the owner or licensee of all intellectual property rights in our Services, including all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics (collectively, the "Content"), as well as the trademarks, service marks, and logos contained therein (the "Marks").',
      "Our Content and Marks are protected by copyright and trademark laws in the United Kingdom and around the world. The Content and Marks are provided through the Services for your personal, non-commercial use or internal business purposes only.",
      "You must not copy, reproduce, aggregate, republish, upload, post, publicly display, encode, translate, transmit, distribute, sell, license, or otherwise exploit any Content or Marks for any commercial purpose whatsoever without our prior written permission.",
    ],
  },
  {
    title: "3. User Representations",
    paras: ["By using the Services, you represent and warrant that:"],
    bullets: [
      "You have the legal capacity to enter into these Legal Terms",
      "You are not a minor in the jurisdiction in which you reside",
      "You will not access the Services through automated or non-human means",
      "You will not use the Services for any illegal or unauthorised purpose",
      "Your use of the Services will not violate any applicable law or regulation.",
    ],
  },
  {
    title: "4. Prohibited Activities",
    paras: [
      "You may not access or use the Services for any purpose other than that for which we make the Services available. As a user of the Services, you agree not to:",
    ],
    bullets: [
      "Systematically retrieve data or other content from the Services to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us",
      "Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information",
      "Circumvent, disable, or otherwise interfere with security-related features of the Services",
      "Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services",
      "Use the Services in a manner inconsistent with any applicable laws or regulations",
      "Upload or transmit viruses or any other material that interferes with any party's uninterrupted use and enjoyment of the Services",
      "Use the Services to advertise or offer to sell goods and services without our consent",
      "Attempt to impersonate another user or person.",
    ],
  },
  {
    title: "5. Third-Party Websites",
    paras: [
      'The Services may contain links to other websites ("Third-Party Websites") as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties ("Third-Party Content").',
      "We are not responsible for any Third-Party Websites accessed through the Services or any Third-Party Content, and we do not investigate, monitor, or check such websites or content for accuracy, appropriateness, or completeness. Inclusion of, linking to, or permitting the use of any Third-Party Websites or Third-Party Content does not imply our approval or endorsement thereof.",
    ],
  },
  {
    title: "6. Services Management",
    paras: ["We reserve the right, but not the obligation, to:"],
    bullets: [
      "Monitor the Services for violations of these Legal Terms",
      "Take appropriate legal action against anyone who violates the law or these Legal Terms",
      "Refuse, restrict access to, limit the availability of, or disable any of your contributions or any portion thereof",
      "Otherwise manage the Services in a manner designed to protect our rights and property.",
    ],
  },
  {
    title: "7. Term and Termination",
    paras: [
      "These Legal Terms shall remain in full force and effect while you use the Services. We reserve the right to deny access to and use of the Services to any person for any reason at our sole discretion.",
      "If we terminate or suspend your access for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action.",
    ],
  },
  {
    title: "8. Modifications and Interruptions",
    paras: [
      "We reserve the right to change, modify, or remove the contents of the Services at any time or for any reason at our sole discretion without notice. We will not be liable to you or any third party for any modification, suspension, or discontinuance of the Services.",
      "We cannot guarantee the Services will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Services, resulting in interruptions, delays, or errors. We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Services at any time without notice to you.",
    ],
  },
  {
    title: "9. Governing Law",
    paras: [
      "These Legal Terms shall be governed by and defined following the laws of Scotland, United Kingdom. Harman AI Solutions and yourself irrevocably consent that the courts of Scotland shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these Legal Terms.",
    ],
  },
  {
    title: "10. Dispute Resolution",
    subsections: [
      {
        heading: "Informal Negotiations",
        paras: [
          "To expedite resolution and control the cost of any dispute, you and we agree to first attempt to negotiate any dispute informally for at least 30 days before initiating arbitration. Such informal negotiations commence upon written notice from one party to the other.",
        ],
      },
      {
        heading: "Binding Arbitration",
        paras: [
          "If informal negotiations are unsuccessful, any dispute arising out of or in connection with these Legal Terms, including any question regarding their existence, validity, or termination, shall be referred to and finally resolved by arbitration. The arbitration shall take place in Edinburgh, Scotland, United Kingdom. The language of the proceedings shall be English.",
        ],
      },
      {
        heading: "Restrictions",
        paras: [
          "The parties agree that any arbitration shall be limited to the dispute between the parties individually. To the full extent permitted by law, no arbitration shall be joined with any other proceeding, and there is no right for any dispute to be arbitrated on a class-action basis or to utilise class action procedures.",
        ],
      },
    ],
  },
  {
    title: "11. Corrections",
    paras: [
      "There may be information on the Services that contains typographical errors, inaccuracies, or omissions. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Services at any time without prior notice.",
    ],
  },
  {
    title: "12. Disclaimer",
    paras: [
      "THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE THEREOF, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.",
      "WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY ERRORS OR OMISSIONS IN ANY CONTENT.",
    ],
  },
  {
    title: "13. Limitations of Liability",
    paras: [
      "TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT OR LOSS OF DATA ARISING FROM YOUR USE OF THE SERVICES.",
      "OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US FOR THE SERVICES DURING THE PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING.",
    ],
  },
  {
    title: "14. Indemnification",
    paras: [
      "You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable legal fees and expenses, made by any third party due to or arising out of:",
    ],
    bullets: [
      "Your use of the Services",
      "Breach of these Legal Terms",
      "Any breach of your representations and warranties set forth in these Legal Terms",
      "Your violation of the rights of a third party, including but not limited to intellectual property rights.",
    ],
  },
  {
    title: "15. User Data",
    paras: [
      "We will maintain certain data that you transmit to the Services for the purpose of managing the performance of the Services, as well as data relating to your use of the Services. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Services.",
      "You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.",
    ],
  },
  {
    title: "16. Electronic Communications",
    paras: [
      "Visiting the Services, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Services, satisfy any legal requirement that such communication be in writing.",
    ],
  },
  {
    title: "17. Miscellaneous",
    paras: [
      "These Legal Terms and any policies or operating rules posted by us on the Services constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Legal Terms shall not operate as a waiver of such right or provision.",
      "These Legal Terms operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.",
      "If any provision or part of a provision of these Legal Terms is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Legal Terms and does not affect the validity and enforceability of any remaining provisions.",
    ],
  },
  {
    title: "18. Contact Us",
    paras: [
      "In order to resolve a complaint regarding the Services or to receive further information regarding use of the Services, please contact us at:",
    ],
    contact: {
      name: "Harman AI Solutions",
      address: "Edinburgh, Scotland, United Kingdom",
      email: "team@harmanaisolutions.com",
      website: "https://harmanaisolutions.com",
    },
  },
];
